const CloseButton = ({ closeToast }: { closeToast: () => void }) => (
  <button
    onClick={closeToast}
    aria-label="Close notification"
    style={{
      background: "none",
      border: "none",
      color: "#ffffff",
      cursor: "pointer",
      fontSize: "18px",
      padding: "4px",
      position: "absolute",
      top: 0,
      right: 0,
    }}
  >
    ✕
  </button>
);

export default CloseButton;
